// @flow
import ReportSection from './ReportSection';

export default ReportSection;
